module.exports = __webpack_public_path__ + "fork.jpg?6777ba9e8b674771e7c84fc8966933b4";